export default {"Users":"Users-module__Users__yMACD","Header":"Users-module__Header__QIiGJ","Footer":"Users-module__Footer__E2gnM"};